import React, { useState } from 'react';
import OrangeButton from '../buttons/orange-button';
import OrangeButtonOutline from '../buttons/orange-button-outline';
import { useNavigate } from 'react-router-dom';
import CustomModal from '../CustomModal';
import SignUpPopup from '../../Pages/tutor-details/components/SignupPopup';

const StudentManagementDashboardSection = () => {
  const navigate = useNavigate();
  const [showSignupModal, setShowSignupModal] = useState(false);

  const features = [
    'Personalised Study Guides',
    'Practice Modules',
    'Browse Tutors',
    'Schedule Sessions',
    'Parent Account Linking',
  ];

  return (
    <div className="mx-auto !mt-[48px] flex flex-col-reverse items-center gap-4 md:!mt-[96px] md:gap-12 lg:flex-row ">
      <div className="container w-full !max-w-[502px] space-y-4 !px-6 md:!pr-0 ">
        <div className="fredokaOne text-[32px] font-normal leading-normal tracking-[-0.8px] text-[#012E33] md:text-[40px] ">
          Student Management Dashboard
        </div>

        <p className="fredoka mt-6 text-[18px] font-normal leading-[145.55%] tracking-[-0.18px] text-[#678285] md:text-[22px]    md:tracking-[-0.22px] ">
          Easily organize your students, track their academic progress, and manage tutoring sessions 
          — all from a single, streamlined dashboard. Save time and stay informed at a glance.
        </p>

        {/* <div className="space-y-4  md:pt-2">
          {features.map((feature, index) => (
            <div key={index} className="flex items-center gap-4 md:gap-6">
              <div className="flex size-10 items-center justify-center rounded-full bg-yellow-100 p-1 md:size-12">
                <img className="size-5 md:size-6" src="/images/icons/CheckFat.svg" alt="" />
              </div>
              <span className="fredoka text-[18px]  font-medium leading-8  tracking-[-0.18px] text-[#012E33] md:text-[22px] md:tracking-[-0.22px]">
                {feature}
              </span>
            </div>
          ))}
        </div> */}

        <div className="flex flex-col gap-4 pt-4 lg:flex-row">
          <OrangeButton
            className="fredokaOne !rounded-2xl"
            onClick={() => setShowSignupModal(true)}
            label={'Try Tutor Dashboards'}
          />
          <OrangeButtonOutline
            onClick={() => navigate('/products/academic-tutoring')}
            label={'Learn More'}
          />
        </div>
      </div>
      <div className="w-full pl-4 lg:w-1/2 lg:p-0">
        <img src="/images/home/academic-tutoring.png" alt="" />
      </div>
      {/* <CustomModal
        className="max-w-[480px]"
        isOpen={showSignupModal}
        onClose={() => setShowSignupModal(false)}
      >
        <SignUpPopup />
      </CustomModal> */}
    </div>
  );
};

export default StudentManagementDashboardSection;
